import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
// import { NgxAlertsService } from '@ngx-plus/ngx-alerts';
import { EventsService } from '../events.service';
import { AlertsService } from 'src/app/components/alerts/alerts.service';

@Injectable({
  providedIn: 'root'
})
export class CheckPointService {

  desc = '';
  points = 0;

  constructor(
    private eventsService: EventsService,
    // private alert: NgxAlertsService,
    private api: ApiService,
    private al: AlertsService,
    private ev: EventsService
  ) { }

  html(points, desc) {
    return `
      <style type="text/css" scoped>

        button.swal2-confirm {
          background-color: #8d793e;
          color: #ffffff;
        }

        button.swal2-cancel {
          display: none !important;
        }

        .points-modal {
      
          p {
            font-size: 18px;
          }
      
          h3 {
              font-size: 1.1rem;
          }
      
          .points-modal-icon {
              width: 200px;
              height: 200px;
              background: url('~src/assets/img/icons/points.png')center no-repeat;
              background-size: 100%;
              display: block;
              margin: auto;
              padding-top: 1.5rem;
      
              h2 {
                  font-size: 50px;
                  line-height: 1;
              }
      
              h3 {
                  font-size: 2rem;
                  line-height: 0.5;
              }
          }
        }
      </style>

      <div  class="points-modal">
        <div class="points-modal-icon text-center">
            <h2>${points}</h2>
            <h3>Points</h3>
        </div>
        <div class="text-center">
            <h3>Congratulations !</h3>
            <p>${desc}</p>
        </div>
      </div>
    `;
  }

  checkPoint(successCallback?: any, errorCallback?: any){
    this.api.getPoint().subscribe((res: any) => {
      if(res.Code === 200){
        let rs = res.Results;
        console.log(rs);
        if('Point' in rs){
          this.al.onAlert.emit({status: 'point', message: rs.Point});
          this.ev.onReloadMyProfile.emit();
          if(successCallback){
            successCallback(rs);
          }

          // this.alert.alert({html: this.html(rs.Point, rs.Description? rs.Description : '')}, () => {
          //   this.getMyProfile();
          //   if(successCallback){
          //     successCallback(rs);
          //   }
          // });
        } else {
          if(errorCallback){
            errorCallback(res);
          }
        }
      } else {
        if(errorCallback){
          errorCallback(res);
        }
      }
    }, (err: any) => {
      throw err;
    });
  }

  getMyProfile() {
    this.api.getMyProfile(this.api.token.toString()).subscribe((res: any) => {
      let rs = res.Results;
      if(rs && 'CurrentPoint' in rs){
        this.eventsService.onPointSubscribe.emit(rs.CurrentPoint);
      }
    });
  }
}
